import { Box, CircularProgress } from '@ltvco/refresh-lib/theme';
import { useFeatureIsOn, useGrowthBook } from '@ltvco/refresh-lib/vendors';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { AccountPageV2 } from 'components/DeepSearch/components/AccountPage';
import { ReportLibraryLandingPage } from 'components/DeepSearch/components/ReportLibrary';
import { MonitoredReportsPage } from 'components/DeepSearch/components/ReportLibrary/MonitoredReports/MonitoredReportsPage';
import { UpgradePlanPage } from 'components/DeepSearch/components/UpgradePlanPage';
import { DEEPSEARCH_ROUTES } from 'components/DeepSearch/constants';
import { ChatLayoutProvider } from 'components/DeepSearch/context/ChatLayoutContext';
import { NotFound } from 'routes';

import { DeepSearchLayoutProvider, DeepSearchProvider } from '../context';

import { DeepSearchLayout } from './DeepSearchLayout';
import { DeepSearchPage } from './DeepSearchPage';
import { LoadingContainer } from './DeepSearchPage.styles';

function ReportLibraryLandingRoute() {
  const { pathname } = useLocation();
  return (
    <ReportLibraryLandingPage
      key={pathname}
      basePath={DEEPSEARCH_ROUTES.chat}
    />
  );
}

interface DeepSearchContainerProps {
  onLogout: () => void;
}

export const DeepSearchContainer = ({ onLogout }: DeepSearchContainerProps) => {
  const gb = useGrowthBook();
  const isInDeepSearchVariation = useFeatureIsOn('prop-3834');

  if (!gb?.ready) {
    return (
      <LoadingContainer>
        <CircularProgress />
      </LoadingContainer>
    );
  }

  if (!isInDeepSearchVariation) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <Box sx={{ height: '100dvh', width: '100%' }}>
      <DeepSearchProvider>
        <ChatLayoutProvider>
          <DeepSearchLayoutProvider>
            <Routes>
              <Route
                path="/*"
                element={<DeepSearchLayout onLogout={onLogout} />}
              >
                <Route
                  index
                  element={<Navigate to={DEEPSEARCH_ROUTES.chat} replace />}
                />
                <Route path="chat" element={<DeepSearchPage />} />
                <Route
                  path="chat/conversation/:contextId?"
                  element={<DeepSearchPage />}
                />
                <Route
                  path="chat/library"
                  element={<ReportLibraryLandingRoute />}
                />
                <Route
                  path="chat/library/monitored"
                  element={<MonitoredReportsPage />}
                />
                <Route
                  path="chat/library/list/:listCode"
                  element={<ReportLibraryLandingRoute />}
                />
                <Route
                  path="chat/library/:breadcrumbTitle"
                  element={<ReportLibraryLandingRoute />}
                />
                <Route
                  path="account"
                  element={
                    <AccountPageV2
                      upgradePath={DEEPSEARCH_ROUTES.upgradePlan}
                    />
                  }
                />
                <Route path="upgrade/plan" element={<UpgradePlanPage />} />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </DeepSearchLayoutProvider>
        </ChatLayoutProvider>
      </DeepSearchProvider>
    </Box>
  );
};
